import React from "react";

import Image from "../../components/image";
import DownloadSvg from "../../images/icons/fi-rr-download.inline.svg";
import { Link } from "../../utils/customLink";

const DownloadBanner = ({
  featuredImage,
  buttonStyle = "",
  labelClass = "",
  iconStyle = "",
  displayTitle = "",
  displayDescription = "",
  ctaLink = "",
  ctaLabel = "Download",
  target = ""
}) => {
  return (
    <div className="rounded-xs flex items-center flex-col sm:flex-row sm:h-full mb-6 gvi-box-shadow bg-white dark:gvi-light-gray-bg">
      <div className="rounded-t-[5px] md:rounded-l-[5px] md:rounded-r-[0] sm:h-auto h-50 w-full sm:w-[38%]">
        <Image
          imageAlt={""}
          image={""}
          imageClass="xs:object-contain sm:object-cover xs:object-center md:object-center"
          sourceUrl={featuredImage}
        />
      </div>

      <div className="flex flex-col items-start flex-1 w-full gap-4 px-4 bg-transparent bg-white rounded-b md:pl-10 dark:gvi-light-gray-bg py-6">
        <div className="w-full">
          <h2
            className="text-[26px] sm:text-xlrg-sm"
            dangerouslySetInnerHTML={{ __html: displayTitle }}
          />
        </div>
        <div className="sm:py-1">
          <div
            className="text-mob text-black-lighter dark:text-gray-generic"
            dangerouslySetInnerHTML={{
              __html: displayDescription
            }}
          />
        </div>
        <div className="md:block w-full md:w-3/5 min-w-[10rem]">
          <div className="flex items-center justify-between">
            <div className="w-full">
              <Link
                to={ctaLink}
                target={target}
                className={`${buttonStyle} group relative z-10 flex flex-row items-center justify-center px-2 py-2 rounded-full dark:rounded-sm text-white dark:text-gray-darker bg-red-light dark:bg-green-standard hover:bg-black-lighter dark:hover:bg-white`}
              >
                <p
                  className={`${labelClass} text-base leading-genericCta font-bold pr-2`}
                >
                  {ctaLabel}
                </p>
                <DownloadSvg
                  className={`${iconStyle} w-5 pr-1 fill-white group-hover:fill-white dark:fill-gray-standard dark:group-hover:fill-gray-darker`}
                />
              </Link>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};
export default DownloadBanner;
